import React, { useEffect } from "react";
import {
  FaLeaf,
  FaHandsHelping,
  FaStar,
  FaTruck,
  FaChevronRight,
  FaShoppingCart,
  FaTshirt,
  FaBoxOpen,
  FaGlobe,
} from "react-icons/fa";
import {
  MdOutlineDesignServices,
  MdFactory,
  MdLocalShipping,
} from "react-icons/md";
import { BsBoxSeam, BsGlobe } from "react-icons/bs";
import { RiCustomerService2Fill } from "react-icons/ri";
import About from "./About";

const AboutUs = () => {
  const themeColor = "#D6C3F0"; // primary-300
  const accentColor = "#B99CE2"; // primary-400
  const secondaryColor = "#8353C6"; // primary-600

  // Process data
  const processes = [
    {
      title: "Ethical Sourcing",
      icon: <FaTshirt className="text-3xl" />,
      description:
        "Globally sourced premium materials with fair trade practices",
      stats: "12 countries",
    },
    {
      title: "Artisan Design",
      icon: <MdOutlineDesignServices className="text-3xl" />,
      description:
        "Collaboration with master weavers and contemporary designers",
      stats: "50+ artisans",
    },
    {
      title: "Precision Manufacturing",
      icon: <MdFactory className="text-3xl" />,
      description: "State-of-the-art facilities with quality at every stage",
      stats: "0 defects policy",
    },
    {
      title: "Global Delivery",
      icon: <MdLocalShipping className="text-3xl" />,
      description: "Eco-friendly packaging with worldwide express shipping",
      stats: "3-5 day delivery",
    },
  ];

  const features = [
    {
      icon: <FaLeaf className="text-3xl" />,
      title: "Eco-Conscious",
      description: "Sustainable materials and carbon-neutral processes",
      bg: "bg-green-50",
    },
    {
      icon: <RiCustomerService2Fill className="text-3xl" />,
      title: "Dedicated Support",
      description: "24/7 customer care with fabric specialists",
      bg: "bg-blue-50",
    },
    {
      icon: <FaStar className="text-3xl" />,
      title: "Uncompromising Quality",
      description: "Five-stage inspection for flawless fabrics",
      bg: "bg-yellow-50",
    },
    {
      icon: <FaTruck className="text-3xl" />,
      title: "Lightning Fast",
      description: "Same-day dispatch for orders before 3PM",
      bg: "bg-red-50",
    },
  ];

  const steps = [
    {
      title: "Browse Fabrics",
      icon: <FaBoxOpen className="text-2xl" />, // fabric box icon
      description:
        "Explore our curated collection of premium fabrics ready for sale",
      color: "text-purple-500",
    },
    {
      title: "Place Order",
      icon: <FaShoppingCart className="text-2xl" />, // shopping cart icon
      description:
        "Select your favorite fabrics and place your order easily online",
      color: "text-indigo-500",
    },
    {
      title: "Fast Delivery",
      icon: <FaTruck className="text-2xl" />,
      description:
        "Receive your fabrics swiftly with our reliable shipping options",
      color: "text-blue-500",
    },
  ];

  return (
    <>
      <div className="bg-white text-gray-800 font-sans">
        {/* Our Story */}
        <section className="py-28 px-6 max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <span
              className="inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4 uppercase tracking-wider"
              style={{ backgroundColor: accentColor, color: secondaryColor }}
            >
              Our Heritage
            </span>
            <h2
              className="text-4xl md:text-5xl font-bold mb-6 "
              style={{
                color: secondaryColor,
                fontFamily: "'Times New Roman', Serif",
              }}
            >
              The Fabric of Our Story
            </h2>
            <div className="w-24 h-1.5 mx-auto mb-8 bg-gradient-to-r from-purple-400 to-indigo-400 rounded-full"></div>
            <p className="max-w-2xl mx-auto text-lg text-gray-600">
              From a single loom to a global textile presence - our journey
              through the warp and weft of time
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="relative group">
              <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-purple-100 to-indigo-100 opacity-70 group-hover:opacity-100 transition-all duration-300 blur-md"></div>
              <img
                crossOrigin="anonymous"
                src="https://res.cloudinary.com/dqjyt9vpd/image/upload/v1754497741/designpatterns/ndcfx04vkfujqqx9ifnu.jpg"
                alt="Our Story"
                className="relative rounded-2xl shadow-2xl w-full h-auto transform group-hover:-translate-y-2 transition-all duration-300"
              />
              <div
                className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-2xl border-l-4 group-hover:scale-105 transition-all"
                style={{ borderColor: themeColor }}
              >
                <h3
                  className="font-bold text-xl mb-1 text-center"
                  style={{ color: secondaryColor }}
                >
                  Founder
                </h3>
                <p className="text-sm text-gray-500 text-center">
                  {" "}
                  BM.Geetha Muthuselvan and CEO OF AAVRYAA TRADERS <br /> Dr.Aavanya
                  Laxmee Vision to Preserve
                </p>
              </div>
            </div>

            <div>
              <div
                className="mb-10 p-8 rounded-2xl bg-white shadow-xl border-l-4 hover:shadow-2xl transition-all"
                style={{ borderColor: themeColor }}
              >
                <p className="text-lg text-gray-700 leading-relaxed">
                  Aavryaa which began in 2016, as a humble Acchoos ladies
                  Boutique with 2000Sq.ft has blossomed into internationally
                  recognized brand launched on June 28, 2024, Founder Geetha
                  Muthuselvan. Vision to Preserve Unique Fabrics + Unique
                  Costume in a gentle and elegant way with fine quality, Premium
                  and Unique Fabrics . While innovating for traditional and
                  Modern Needs.
                </p>
              </div>
              <ul className="space-y-5">
                {[
                  {
                    text: "1000+ exclusive fabric designs",
                    icon: <FaBoxOpen />,
                  },
                  {
                    text: "Ethical partnerships with 50+ artisan communities",
                    icon: <FaHandsHelping />,
                  },
                  {
                    text: "Sustainable production with 70% renewable energy",
                    icon: <FaLeaf />,
                  },
                  {
                    text: "Global shipping to 35+ countries",
                    icon: <BsGlobe />,
                  },
                ].map((item, i) => (
                  <li key={i} className="flex items-start group">
                    <span className="inline-flex items-center justify-center mr-4 mt-1 w-8 h-8 rounded-full bg-purple-100 text-purple-600 group-hover:bg-purple-600 group-hover:text-white transition-all">
                      {item.icon}
                    </span>
                    <span className="text-gray-700 group-hover:text-gray-900 transition-all">
                      {item.text}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <About />
        {/* Mission & Vision */}
        <section className="py-28 px-6 bg-cover bg-fixed bg-center relative">
          <div className="absolute inset-0 bg-purple-800/80 backdrop-blur-sm"></div>
          <div className="relative max-w-7xl mx-auto">
            <div className="text-center mb-20">
              <span className="inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4 uppercase tracking-wider text-white bg-white/20 backdrop-blur-sm">
                Our Philosophy
              </span>
              <h2
                className="text-4xl md:text-5xl font-bold mb-6 text-white"
                style={{ fontFamily: "'Times New Roman', Serif" }}
              >
                Threads of Purpose
              </h2>
              <div className="w-24 h-1.5 mx-auto mb-8 bg-gradient-to-r from-purple-300 to-pink-300 rounded-full"></div>
              <p className="max-w-2xl mx-auto text-lg text-purple-100">
                The principles that weave through everything we create
              </p>
            </div>

            <div className="grid lg:grid-cols-2 gap-10">
              <div className="bg-white/10 backdrop-blur-lg p-10 rounded-3xl shadow-xl border border-white/20 transform hover:-translate-y-3 transition-all duration-500">
                <div className="w-20 h-20 rounded-2xl flex items-center justify-center mb-8 bg-gradient-to-br from-purple-500 to-indigo-500 shadow-lg">
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    ></path>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold mb-6 text-white">
                  Our Mission
                </h3>
                <p className="text-purple-100 leading-relaxed">
                  To redefine luxury textiles by harmonizing ancient
                  craftsmanship with sustainable innovation, creating fabrics
                  that tell stories while respecting our planet. We're committed
                  to ethical practices that uplift artisan communities
                  worldwide.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-lg p-10 rounded-3xl shadow-xl border border-white/20 transform hover:-translate-y-3 transition-all duration-500">
                <div className="w-20 h-20 rounded-2xl flex items-center justify-center mb-8 bg-gradient-to-br from-pink-500 to-rose-500 shadow-lg">
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                    ></path>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold mb-6 text-white">
                  Our Vision
                </h3>
                <p className="text-purple-100 leading-relaxed">
                  To be the global benchmark for responsible luxury textiles by
                  2030, where every yard of fabric represents environmental
                  stewardship, cultural preservation, and design innovation. We
                  envision a world where textiles heal rather than harm.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="py-28 px-6 max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <span
              className="inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4 uppercase tracking-wider"
              style={{ backgroundColor: accentColor, color: secondaryColor }}
            >
              Experience
            </span>
            <h2
              className="text-4xl md:text-5xl font-bold mb-6"
              style={{
                color: secondaryColor,
                fontFamily: "'Times New Roman', Serif",
              }}
            >
              Seamless From Start to Finish
            </h2>
            <div className="w-24 h-1.5 mx-auto mb-8 bg-gradient-to-r from-purple-400 to-indigo-400 rounded-full"></div>
            <p className="max-w-2xl mx-auto text-lg text-gray-600">
              How we bring premium fabrics to your creative projects
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 relative">
            <div className="absolute top-1/2 left-0 right-0 h-1 bg-gray-200 hidden md:block"></div>
            {steps.map((step, i) => (
              <div
                key={i}
                className="relative bg-white p-10 rounded-2xl shadow-xl z-10 transform hover:-translate-y-5 transition-all duration-300"
              >
                <div className="absolute -top-6 -left-6 w-12 h-12 rounded-full flex items-center justify-center text-white font-bold shadow-lg bg-gradient-to-br from-purple-500 to-indigo-500">
                  {i + 1}
                </div>
                <div
                  className={`w-16 h-16 rounded-xl flex items-center justify-center mb-6 mx-auto bg-gradient-to-br from-purple-100 to-indigo-100 ${step.color}`}
                >
                  {step.icon}
                </div>
                <h4
                  className="font-bold text-xl mb-4 text-center"
                  style={{ color: secondaryColor }}
                >
                  {step.title}
                </h4>
                <p className="text-gray-600 text-center">{step.description}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutUs;
